module.exports = "/_next/static/images/68a058469e603c3b2af329ac98325666-card-lock-new.svg";